import { removeKeyFromState } from '../../util/reducers'
import { CLEAR_ERROR, SET_ERROR } from './actions'

export function errors(state = {}, action) {
  const { domId, error } = action

  switch (action.type) {
    case SET_ERROR:
      return {
        ...state,
        [domId]: error,
      }
    case CLEAR_ERROR:
      return removeKeyFromState(state, domId)
    default:
      return state
  }
}
